import { Box, Grid, Skeleton, Stack } from '@mui/material';
import React from 'react';

export default function AIHistoryChatComponentLoading() {
    const messages = [
        500, 400, 250, 600, 400, 500, 200, 400, 300, 500, 200, 450, 400, 250,
        600, 400, 500, 200,
    ];

    return (
        <Grid
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Stack
                spacing={2}
                flex={1}
                sx={{
                    paddingTop: '50px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    width: '100%',
                    pr: 1,
                }}
            >
                {messages?.map((message: any, index: any) => {
                    return (
                        <Box
                            display='flex'
                            flexDirection='column'
                            width='100%'
                            alignSelf={index % 2 ? 'flex-end' : 'flex-start'}
                            alignItems={index % 2 ? 'flex-end' : 'flex-start'}
                        >
                            {message.renderMessage !== false && (
                                <Skeleton
                                    variant='text'
                                    sx={{
                                        fontSize: '3rem',
                                        width: `${message}px`,
                                    }}
                                />
                            )}
                        </Box>
                    );
                })}
            </Stack>
        </Grid>
    );
}
